import '../styles/contact.css'
import { faTiktok, faInstagram, faGooglePay, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faEarthEurope, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Fade from 'react-reveal/Fade';

export default function Contact() {
    return (

        <div className="Contact">

<Fade top>
                <div className='cardContact'>

                    <div className='emailContact'>
                   <a className='faContact'> <FontAwesomeIcon icon={faEnvelope} /></a>
                    <h2>Email</h2>
                    <a>biancaappsdev@gmail.com</a>
                    
                    </div>
                    <div className='locationContact'>
                    <a className='faContact'><FontAwesomeIcon icon={faEarthEurope} /></a>
                    <h2>Headquarters</h2>
                    <a>Bacau, Romania</a>
                    </div>

                </div>
                <div className='socialContact'>
                    <div className='titleContact'>
                        <h1></h1>

                    </div>

                    <div className='iconContact'>

                       
                        <li><a className='googlePlay' href='https://play.google.com/store/apps/dev?id=6256207236238699098'><FontAwesomeIcon icon={faGooglePay} /></a></li>
                        <li><a className='tiktok' href='https://www.tiktok.com/@eosrmg'><FontAwesomeIcon icon={faTiktok} /></a></li>
                        <li><a className='instagram' href='https://www.instagram.com/eosrmg_developer/'><FontAwesomeIcon icon={faInstagram} /></a></li>
                        <li><a className='youtube' href='https://www.youtube.com/channel/UCUzEYts1gAURebNLCcEtHoA'><FontAwesomeIcon icon={faYoutube} /></a></li>


                    </div>

                </div>

            </Fade>
        </div>
    );
}